<template>
  <div>
    <el-form
      :model="otaForm"
      :rules="rules"
      ref="otaForm"
      style="margin-right: 30px"
    >
      <el-form-item label="版本号" :label-width="formLabelWidth" prop="version">
        <el-input
          v-model="otaForm.version"
          autocomplete="off"
          @blur="verBlur"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="OTA文件"
        :label-width="formLabelWidth"
        style="height: 230px"
        prop="uploadFile"
      >
        <el-upload
          accept="bin"
          name="file"
          :headers="uploadHeaders"
          :data="otaForm"
          ref="upload"
          drag
          :auto-upload="false"
          :action="uploadActionUrl"
          :limit="1"
          :on-change="selectFile"
          :on-success="uploadSuccess"
          :on-error="uploadFail"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>

      <el-form-item
        v-if="isY007 || isY003"
        label="固件类型"
        :label-width="formLabelWidth"
        prop="otaType"
      >
        <el-select
          style="margin-right: 30px"
          clearable
          v-model="otaForm.otaType"
          filterable
          placeholder="请选择更新"
        >
          <el-option
            v-for="item in otaOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :index="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        v-if="!(isY007 || isY003)"
        label="是否更新"
        :label-width="formLabelWidth"
        prop="forceUpdate"
      >
        <el-select
          :disabled="!$jumpPerm('update_tip')"
          style="margin-right: 30px"
          clearable
          v-model="otaForm.forceUpdate"
          filterable
          placeholder="请选择更新"
        >
          <el-option
            v-for="item in updateOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :index="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 升级文件类型 -->
      <el-form-item
        label="升级文件类型"
        :label-width="formLabelWidth"
        prop="type"
      >
        <el-select
          style="margin-right: 30px"
          clearable
          v-model="otaForm.type"
          filterable
          placeholder="请选择升级文件类型"
        >
          <el-option
            v-for="item in updatefileOption"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :index="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <!-- 偏移量 -->
      <el-form-item label="偏移量" :label-width="formLabelWidth" prop="addr">
        <el-input v-model="otaForm.addr" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item
        label="设备型号"
        :label-width="formLabelWidth"
        prop="socType"
      >
        <el-select
          style="margin-right: 30px"
          clearable
          v-model="otaForm.socType"
          filterable
          placeholder="请选择设备型号"
        >
          <el-option
            v-for="item in socTypeList"
            :key="item.value"
            :label="item.name"
            :value="item.value"
            :index="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        label="版本说明"
        :label-width="formLabelWidth"
        prop="description"
      >
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 10 }"
          placeholder="请输入内容"
          v-model="otaForm.description"
        >
        </el-input>
      </el-form-item>

      <el-form-item :label-width="formLabelWidth" label="">
        <div style="margin-right: 30px">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button
            type="primary"
            @click="confirmAction('otaForm')"
            :disabled="disableSubmit"
            >确 定</el-button
          >
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { API_URL, requestHeaders } from "../../api/request";

export default {
  name: "AddOtaForm",

  watch: {
    project(newValue, oldValue) {
      console.log("newValue-->", newValue);
      if (newValue) {
        this.clearData(true);
        console.log("typeof newValue-->", typeof newValue);
        this.otaForm.projectId = newValue.id;
      }
    },
  },
  created() {
    console.log("this.otaForm-->", this.otaForm);
  },
  mounted() {
    console.log("API_URL-->", API_URL);
    console.log("pId-->", this.project.id);
    this.otaForm.projectId = this.project.id;
    console.log("otaForm-->", this.otaForm);
    console.log("otaForm.pId-->", this.otaForm.projectId);
  },
  methods: {
    closeDialog() {
      this.clearData();
      this.$emit("clickCancel");
    },
    confirmAction(formName) {
      console.log("uploadHeaders-->", this.uploadHeaders);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.disableSubmit = true;
          this.$refs.upload.submit();
        } else {
          return false;
        }
      });
    },
    clearData(flag) {
      if (flag) {
        this.otaForm.projectId = -1;
      }
      this.otaForm.version = "";
      this.otaForm.socType = "";
      this.otaForm.uploadFile = null;
      this.otaForm.description = "";
      this.otaForm.otaType = null;
      this.otaForm.forceUpdate = 2;
      this.$refs["upload"].clearFiles();
    },
    uploadFail(response, file, fileList) {
      this.disableSubmit = false;
    },
    uploadSuccess(response, file, fileList) {
      this.disableSubmit = false;
      console.log("rep-->", response);
      if (response.code === 1000) {
        this.$message.success("保存成功");
      } else {
        this.$message.error(response.msg);
      }
      this.clearData();
      this.$emit("successCreateOta");
    },
    selectFile(file, list) {
      this.otaForm.uploadFile = file;

      console.log("typeof file-->", typeof file);
      console.log("file-->", file);
    },
    verBlur(e) {
      const val = e.target.value;
      if (this.isY006 && val.includes(".")) {
        const vs = ["0", "0", "0", "0", ...val.split(".")];
        this.otaForm.version = vs
          .splice(-4)
          .map((s) => (s * 1).toString(16).toUpperCase())
          .map((s, i) => ("000" + s).substr(-(i == 0 ? 1 : i == 3 ? 3 : 2)))
          .join("");
      }
      if (this.isY001S && val.includes(".")) {
        const vs = ["0", "0", "0", "0", ...val.split(".")];
        this.otaForm.version = vs
          .splice(-4)
          .map((s) => (s * 1).toString(16).toUpperCase())
          .map((s, i) => ("00" + s).substr(-2))
          .join("");
      }
    },
  },
  props: {
    project: {
      type: Object,
      default: { id: -1 },
    },
    socTypeList: {
      type: Array,
      default: [],
    },
  },
  computed: {
    isY007() {
      return this.project.number?.startsWith("Y007") || false;
    },
    isY003() {
      return this.project?.number?.startsWith("Y003") || false;
    },
    isY006() {
      return this.project?.deviceName == "Y006" || false;
    },
    isY001S() {
      return this.project?.deviceName == "Y001S" || false;
    },
  },
  data() {
    return {
      disableSubmit: false,
      uploadHeaders: requestHeaders("/ota/create"),
      uploadActionUrl: API_URL + "/ota/create",
      rules: {
        projectId: [
          {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
        ],
        version: [
          {
            required: true,
            message: "请输入版本号",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (this.isY006) {
                if (value.length > 8) {
                  callback(new Error("长度不能超过8位"));
                }
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        description: [
          {
            required: true,
            message: "请输入说明",
            trigger: "blur",
          },
        ],
        uploadFile: [
          {
            required: true,
            message: "请选择上传文件",
            trigger: "change",
          },
        ],
        otaType: [
          {
            required: true,
            message: "请选择固件类型",
            trigger: "change",
          },
        ],
        // addr:[
        //   {
        //     required: true,
        //     message: '请输入偏移量',
        //     trigger: 'blur'
        //   }
        // ]
      },
      fileList: [],
      updatefileOption: [
        {
          name: "BLE SoC固件",
          value: 1,
        },
        {
          name: "单个图片资源文件",
          value: 2,
        },
        {
          name: "整个图片资源打包文件",
          value: 3,
        },
        {
          name: "字库文件",
          value: 4,
        },
        {
          name: "JSON配置文件",
          value: 5,
        },
        {
          name: "保留",
          value: 6,
        },
      ],
      updateOptions: [
        {
          name: "强制更新",
          value: 1,
        },
        {
          name: "建议更新",
          value: 2,
        },
        {
          name: "不做任何操作",
          value: 0,
        },
      ],
      otaOptions: [
        {
          name: "App包",
          value: 0,
        },
        {
          name: "Manage包",
          value: 1,
        },
      ],
      otaForm: {
        projectId: -1,
        version: "",
        description: "",
        uploadFile: null,
        forceUpdate: 2,
        type: 1,
        addr: "",
        socType: "",
        otaType: null,
      },

      formLabelWidth: "100px",
    };
  },
};
</script>

<style scoped></style>
